import React, { useEffect, useState } from 'react';
import { Svg } from '../Svg';

export function GpcBanner({
  text,
  backgroundColor,
  gpcBannerGpcEnabled = false,
  gpcBannerDntEnabled = false,
}) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed =
      typeof window !== 'undefined' &&
      sessionStorage.getItem('gpcBannerDismissed') === '1';

    const gpc =
      typeof navigator !== 'undefined' && navigator.globalPrivacyControl;
    const dnt =
      typeof navigator !== 'undefined' && navigator.doNotTrack === '1';

    if (!dismissed) {
      const shouldShow =
        (gpcBannerGpcEnabled && gpc) || (gpcBannerDntEnabled && dnt);
      setShow(shouldShow);
    }
  }, [gpcBannerGpcEnabled, gpcBannerDntEnabled]);

  if (!show) return null;

  return (
    <div
      role="alert"
      className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-between px-4 py-3 text-sm"
      style={{ backgroundColor: backgroundColor || '#CCE0F1' }}
      aria-describedby="gpc-banner-message"
    >
      <p id="gpc-banner-message" className="mr-4 flex w-full justify-center">
        {text}
      </p>
      <button
        type="button"
        aria-label="Close banner"
        onClick={() => {
          setShow(false);
          if (typeof window !== 'undefined') {
            sessionStorage.setItem('gpcBannerDismissed', '1');
          }
        }}
        className="ml-auto flex items-center"
      >
        <Svg
          src="/svgs/close.svg#close"
          viewBox="0 0 24 24"
          className="h-3 w-3"
          aria-hidden="true"
        />
      </button>
    </div>
  );
}

GpcBanner.displayName = 'GpcBanner';
